__turbopack_context__.v({
  "anchor": "payment-funnel-module-scss-module__zGyUDG__anchor",
  "card": "payment-funnel-module-scss-module__zGyUDG__card",
  "section": "payment-funnel-module-scss-module__zGyUDG__section",
});
